import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import TemplatePreview from '../../../shop/StoreGallery/TemplatePreview';

// One look, drawn as a real preview rather than named. A season carries looks called
// FALL27-02 and U2027-07; as a list of names they are unpickable, which is why this
// renders the actual template with a sample photo in it.
//
// Shared by the card-image grid and the per-pose table (PoseSetup), so the two
// cannot drift into drawing a look differently.
// A season can carry 30+ styles, which uncapped pushed the page past 1700px and
// scrolled the sticky preview out of reach.
const gridSx = {
  display: 'flex',
  gap: 1,
  flexWrap: 'wrap',
  maxHeight: 340,
  overflowY: 'auto',
  p: 0.5,
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
};

const StyleTile = ({
  style, sample, on, onClick, label,
}) => (
  <ButtonBase
    onClick={onClick}
    title={style ? style.name : 'Plain photo'}
    sx={{
      width: 104,
      borderRadius: 1,
      border: 2,
      p: 0.5,
      display: 'block',
      borderColor: on ? 'primary.main' : 'divider',
    }}
  >
    {/* Always light: a style preview is the shopper's view, not the admin's. */}
    <Box sx={{
      height: 96, overflow: 'hidden', borderRadius: 0.5, bgcolor: '#f4f4f4',
    }}
    >
      <TemplatePreview
        template={style}
        photoUrl={sample && sample.watermark_url}
        backgroundUrl={null}
        studentName="Sample"
        style={{ width: '100%', height: '100%' }}
      />
    </Box>
    <Typography variant="caption" noWrap display="block" sx={{ mt: 0.25 }}>
      {label || (style ? style.name : 'Plain photo')}
    </Typography>
  </ButtonBase>
);

StyleTile.propTypes = {
  // A Shop::TemplateSerializer look, or null for the plain-photo tile.
  style: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  // The pose the tile previews -- the bundled placeholder, or a sampled student.
  sample: PropTypes.shape({ watermark_url: PropTypes.string }),
  on: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};

StyleTile.defaultProps = {
  style: null, sample: null, on: false, label: null,
};

export { gridSx };
export default StyleTile;
